// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/knowledge.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/knowledge.proto.
 */
export const file_api_proto_v1_knowledge: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * ドメイン（知識パーティション）
 *
 * @generated from message api_proto.v1.KnowledgeDomain
 */
export type KnowledgeDomain = Message<"api_proto.v1.KnowledgeDomain"> & {
  /**
   * ULID (26 文字)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string domain_key = 2;
   */
  domainKey: string;

  /**
   * @generated from field: string label = 3;
   */
  label: string;

  /**
   * @generated from field: int32 sort_order = 4;
   */
  sortOrder: number;
};

/**
 * Describes the message api_proto.v1.KnowledgeDomain.
 * Use `create(KnowledgeDomainSchema)` to create a new message.
 */
export const KnowledgeDomainSchema: GenMessage<KnowledgeDomain> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 0);

/**
 * 文書のサマリ（一覧・ダッシュボード用）
 *
 * @generated from message api_proto.v1.KnowledgeDocumentSummary
 */
export type KnowledgeDocumentSummary = Message<"api_proto.v1.KnowledgeDocumentSummary"> & {
  /**
   * ULID
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 'roof-materials' 等。環境間で安定な自然キー
   *
   * @generated from field: string slug = 2;
   */
  slug: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string domain_key = 4;
   */
  domainKey: string;

  /**
   * @generated from field: string domain_label = 5;
   */
  domainLabel: string;

  /**
   * @generated from field: api_proto.v1.KnowledgeScope scope = 6;
   */
  scope: KnowledgeScope;

  /**
   * @generated from field: int32 section_count = 7;
   */
  sectionCount: number;

  /**
   * open 状態の要監修フラグ数
   *
   * @generated from field: int32 open_flag_count = 8;
   */
  openFlagCount: number;

  /**
   * @generated from field: google.protobuf.Timestamp updated = 9;
   */
  updated?: Timestamp;

  /**
   * 前提・免責（文書全体に効く前置きコンテキスト。空 = 未設定）。
   * RAG では当該文書由来の全チャンクに前置される想定
   *
   * @generated from field: string premise = 10;
   */
  premise: string;

  /**
   * 知識ユニットの粒度（インポータ / 文書作成時に決まる。編集 UI は持たない）
   *
   * @generated from field: api_proto.v1.KnowledgeGranularity granularity = 11;
   */
  granularity: KnowledgeGranularity;
};

/**
 * Describes the message api_proto.v1.KnowledgeDocumentSummary.
 * Use `create(KnowledgeDocumentSummarySchema)` to create a new message.
 */
export const KnowledgeDocumentSummarySchema: GenMessage<KnowledgeDocumentSummary> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 1);

/**
 * 節のサマリ（文書ブラウザのツリー用）
 *
 * @generated from message api_proto.v1.KnowledgeSectionSummary
 */
export type KnowledgeSectionSummary = Message<"api_proto.v1.KnowledgeSectionSummary"> & {
  /**
   * ULID
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * '4-3' '4-3/02' '0'（前文節）等。文書内一意・永久不変
   *
   * @generated from field: string section_key = 2;
   */
  sectionKey: string;

  /**
   * @generated from field: int32 chapter_no = 3;
   */
  chapterNo: number;

  /**
   * 文書内表示順
   *
   * @generated from field: int32 seq = 4;
   */
  seq: number;

  /**
   * @generated from field: string heading = 5;
   */
  heading: string;

  /**
   * @generated from field: string content_type = 6;
   */
  contentType: string;

  /**
   * @generated from field: api_proto.v1.KnowledgeSectionStatus status = 7;
   */
  status: KnowledgeSectionStatus;

  /**
   * @generated from field: api_proto.v1.KnowledgeMaturity maturity = 8;
   */
  maturity: KnowledgeMaturity;

  /**
   * @generated from field: int32 open_flag_count = 9;
   */
  openFlagCount: number;
};

/**
 * Describes the message api_proto.v1.KnowledgeSectionSummary.
 * Use `create(KnowledgeSectionSummarySchema)` to create a new message.
 */
export const KnowledgeSectionSummarySchema: GenMessage<KnowledgeSectionSummary> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 2);

/**
 * 節の全体（エディタ用）
 *
 * @generated from message api_proto.v1.KnowledgeSection
 */
export type KnowledgeSection = Message<"api_proto.v1.KnowledgeSection"> & {
  /**
   * ULID
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string document_id = 2;
   */
  documentId: string;

  /**
   * @generated from field: string document_slug = 3;
   */
  documentSlug: string;

  /**
   * @generated from field: string document_title = 4;
   */
  documentTitle: string;

  /**
   * @generated from field: string section_key = 5;
   */
  sectionKey: string;

  /**
   * @generated from field: int32 chapter_no = 6;
   */
  chapterNo: number;

  /**
   * @generated from field: int32 seq = 7;
   */
  seq: number;

  /**
   * @generated from field: string heading = 8;
   */
  heading: string;

  /**
   * '文書名 > 章 > 節' の見出しパス（保存時にサーバーが再計算）
   *
   * @generated from field: string breadcrumb = 9;
   */
  breadcrumb: string;

  /**
   * 節本文（markdown。glossary 文書では ### 用語見出しを含む）
   *
   * @generated from field: string body = 10;
   */
  body: string;

  /**
   * @generated from field: string content_type = 11;
   */
  contentType: string;

  /**
   * 矛盾知識の用途書き分け。監修者が読む日本語の自由記述（例: '判断根拠の説明' / 'セルフチェックの目安'。空 = 未設定）
   *
   * @generated from field: string usage_context = 12;
   */
  usageContext: string;

  /**
   * 'kyokasho'|'research'|'contribution'|'internal'
   *
   * @generated from field: string source_type = 13;
   */
  sourceType: string;

  /**
   * @generated from field: api_proto.v1.KnowledgeSectionStatus status = 14;
   */
  status: KnowledgeSectionStatus;

  /**
   * @generated from field: api_proto.v1.KnowledgeMaturity maturity = 15;
   */
  maturity: KnowledgeMaturity;

  /**
   * 鮮度（YYYY-MM-DD。空 = 未設定）
   *
   * @generated from field: string as_of = 16;
   */
  asOf: string;

  /**
   * 鮮度棚卸し期日（YYYY-MM-DD。空 = 未設定）
   *
   * @generated from field: string review_after = 17;
   */
  reviewAfter: string;

  /**
   * 原典ページ（'p.023' 等）
   *
   * @generated from field: string source_page = 18;
   */
  sourcePage: string;

  /**
   * 楽観ロック用。UpdateKnowledgeSection の base_revision_no に渡す
   *
   * @generated from field: int32 current_revision_no = 19;
   */
  currentRevisionNo: number;

  /**
   * @generated from field: google.protobuf.Timestamp updated = 20;
   */
  updated?: Timestamp;
};

/**
 * Describes the message api_proto.v1.KnowledgeSection.
 * Use `create(KnowledgeSectionSchema)` to create a new message.
 */
export const KnowledgeSectionSchema: GenMessage<KnowledgeSection> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 3);

/**
 * 節の版
 *
 * @generated from message api_proto.v1.KnowledgeSectionRevision
 */
export type KnowledgeSectionRevision = Message<"api_proto.v1.KnowledgeSectionRevision"> & {
  /**
   * ULID
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int32 revision_no = 2;
   */
  revisionNo: number;

  /**
   * @generated from field: string heading = 3;
   */
  heading: string;

  /**
   * @generated from field: string body = 4;
   */
  body: string;

  /**
   * @generated from field: string change_reason = 5;
   */
  changeReason: string;

  /**
   * 編集主体の表示名（admin 氏名 or 'import:v1-migration' 等の機械主体）
   *
   * @generated from field: string edited_by = 6;
   */
  editedBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp created = 7;
   */
  created?: Timestamp;
};

/**
 * Describes the message api_proto.v1.KnowledgeSectionRevision.
 * Use `create(KnowledgeSectionRevisionSchema)` to create a new message.
 */
export const KnowledgeSectionRevisionSchema: GenMessage<KnowledgeSectionRevision> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 4);

/**
 * 要監修フラグ
 *
 * @generated from message api_proto.v1.KnowledgeReviewFlag
 */
export type KnowledgeReviewFlag = Message<"api_proto.v1.KnowledgeReviewFlag"> & {
  /**
   * ULID
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string section_id = 2;
   */
  sectionId: string;

  /**
   * @generated from field: string document_slug = 3;
   */
  documentSlug: string;

  /**
   * @generated from field: string document_title = 4;
   */
  documentTitle: string;

  /**
   * @generated from field: string section_key = 5;
   */
  sectionKey: string;

  /**
   * @generated from field: string section_heading = 6;
   */
  sectionHeading: string;

  /**
   * @generated from field: api_proto.v1.KnowledgeFlagCategory category = 7;
   */
  category: KnowledgeFlagCategory;

  /**
   * フラグ理由（リサーチ担当の原文）
   *
   * @generated from field: string reason = 8;
   */
  reason: string;

  /**
   * 該当文の抜粋（本文改版後も文脈を追うため）
   *
   * @generated from field: string quote = 9;
   */
  quote: string;

  /**
   * 一括承認のグルーピングキー（'{slug}/{章}/{category}'）
   *
   * @generated from field: string group_key = 10;
   */
  groupKey: string;

  /**
   * 'critical'|'high'|'normal'|'low'|'trivial'（優先度降順の 5 段階。既存データは high / normal のみ）
   *
   * @generated from field: string severity = 11;
   */
  severity: string;

  /**
   * @generated from field: api_proto.v1.KnowledgeFlagStatus status = 12;
   */
  status: KnowledgeFlagStatus;

  /**
   * メモ（判断前でも記入できる。判断時の記録を兼ねる）
   *
   * @generated from field: string resolution_note = 13;
   */
  resolutionNote: string;

  /**
   * 解決者の表示名（未解決は空）
   *
   * @generated from field: string resolved_by = 14;
   */
  resolvedBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp resolved_at = 15;
   */
  resolvedAt?: Timestamp;

  /**
   * 'import:v1'|'admin:{id}' 等
   *
   * @generated from field: string created_by = 16;
   */
  createdBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp created = 17;
   */
  created?: Timestamp;

  /**
   * 監修者への論点
   *
   * @generated from field: string review_point = 18;
   */
  reviewPoint: string;

  /**
   * 節内出現順・1始まり・0=不明
   *
   * @generated from field: int32 position_seq = 19;
   */
  positionSeq: number;
};

/**
 * Describes the message api_proto.v1.KnowledgeReviewFlag.
 * Use `create(KnowledgeReviewFlagSchema)` to create a new message.
 */
export const KnowledgeReviewFlagSchema: GenMessage<KnowledgeReviewFlag> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 5);

/**
 * ダッシュボード: 分類別 open 件数
 *
 * @generated from message api_proto.v1.KnowledgeDashboardCategoryCount
 */
export type KnowledgeDashboardCategoryCount = Message<"api_proto.v1.KnowledgeDashboardCategoryCount"> & {
  /**
   * @generated from field: api_proto.v1.KnowledgeFlagCategory category = 1;
   */
  category: KnowledgeFlagCategory;

  /**
   * @generated from field: int32 open_count = 2;
   */
  openCount: number;
};

/**
 * Describes the message api_proto.v1.KnowledgeDashboardCategoryCount.
 * Use `create(KnowledgeDashboardCategoryCountSchema)` to create a new message.
 */
export const KnowledgeDashboardCategoryCountSchema: GenMessage<KnowledgeDashboardCategoryCount> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 6);

/**
 * ダッシュボード: 成熟度別の節数
 *
 * @generated from message api_proto.v1.KnowledgeDashboardMaturityCount
 */
export type KnowledgeDashboardMaturityCount = Message<"api_proto.v1.KnowledgeDashboardMaturityCount"> & {
  /**
   * @generated from field: api_proto.v1.KnowledgeMaturity maturity = 1;
   */
  maturity: KnowledgeMaturity;

  /**
   * @generated from field: int32 section_count = 2;
   */
  sectionCount: number;
};

/**
 * Describes the message api_proto.v1.KnowledgeDashboardMaturityCount.
 * Use `create(KnowledgeDashboardMaturityCountSchema)` to create a new message.
 */
export const KnowledgeDashboardMaturityCountSchema: GenMessage<KnowledgeDashboardMaturityCount> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 7);

/**
 * ダッシュボード: 文書別の行
 *
 * @generated from message api_proto.v1.KnowledgeDashboardDocumentRow
 */
export type KnowledgeDashboardDocumentRow = Message<"api_proto.v1.KnowledgeDashboardDocumentRow"> & {
  /**
   * @generated from field: string document_slug = 1;
   */
  documentSlug: string;

  /**
   * @generated from field: string document_title = 2;
   */
  documentTitle: string;

  /**
   * @generated from field: int32 open_flag_total = 3;
   */
  openFlagTotal: number;

  /**
   * @generated from field: repeated api_proto.v1.KnowledgeDashboardCategoryCount category_counts = 4;
   */
  categoryCounts: KnowledgeDashboardCategoryCount[];

  /**
   * @generated from field: repeated api_proto.v1.KnowledgeDashboardMaturityCount maturity_counts = 5;
   */
  maturityCounts: KnowledgeDashboardMaturityCount[];

  /**
   * @generated from field: int32 section_count = 6;
   */
  sectionCount: number;

  /**
   * 執筆対象の節数（未執筆・教科書由来のうち章見出し節を除く。執筆キューの長さと一致）
   *
   * @generated from field: int32 write_target_count = 7;
   */
  writeTargetCount: number;
};

/**
 * Describes the message api_proto.v1.KnowledgeDashboardDocumentRow.
 * Use `create(KnowledgeDashboardDocumentRowSchema)` to create a new message.
 */
export const KnowledgeDashboardDocumentRowSchema: GenMessage<KnowledgeDashboardDocumentRow> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 8);

/**
 * @generated from message api_proto.v1.GetKnowledgeReviewDashboardRequest
 */
export type GetKnowledgeReviewDashboardRequest = Message<"api_proto.v1.GetKnowledgeReviewDashboardRequest"> & {
};

/**
 * Describes the message api_proto.v1.GetKnowledgeReviewDashboardRequest.
 * Use `create(GetKnowledgeReviewDashboardRequestSchema)` to create a new message.
 */
export const GetKnowledgeReviewDashboardRequestSchema: GenMessage<GetKnowledgeReviewDashboardRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 9);

/**
 * @generated from message api_proto.v1.GetKnowledgeReviewDashboardResponse
 */
export type GetKnowledgeReviewDashboardResponse = Message<"api_proto.v1.GetKnowledgeReviewDashboardResponse"> & {
  /**
   * @generated from field: int32 open_flag_total = 1;
   */
  openFlagTotal: number;

  /**
   * @generated from field: int32 section_total = 2;
   */
  sectionTotal: number;

  /**
   * @generated from field: repeated api_proto.v1.KnowledgeDashboardCategoryCount category_totals = 3;
   */
  categoryTotals: KnowledgeDashboardCategoryCount[];

  /**
   * @generated from field: repeated api_proto.v1.KnowledgeDashboardMaturityCount maturity_totals = 4;
   */
  maturityTotals: KnowledgeDashboardMaturityCount[];

  /**
   * @generated from field: repeated api_proto.v1.KnowledgeDashboardDocumentRow document_rows = 5;
   */
  documentRows: KnowledgeDashboardDocumentRow[];
};

/**
 * Describes the message api_proto.v1.GetKnowledgeReviewDashboardResponse.
 * Use `create(GetKnowledgeReviewDashboardResponseSchema)` to create a new message.
 */
export const GetKnowledgeReviewDashboardResponseSchema: GenMessage<GetKnowledgeReviewDashboardResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 10);

/**
 * @generated from message api_proto.v1.ListKnowledgeReviewFlagsRequest
 */
export type ListKnowledgeReviewFlagsRequest = Message<"api_proto.v1.ListKnowledgeReviewFlagsRequest"> & {
  /**
   * 空 = 全文書
   *
   * @generated from field: string document_slug = 1;
   */
  documentSlug: string;

  /**
   * UNSPECIFIED = 全分類
   *
   * @generated from field: api_proto.v1.KnowledgeFlagCategory category = 2;
   */
  category: KnowledgeFlagCategory;

  /**
   * UNSPECIFIED = OPEN を既定とする
   *
   * @generated from field: api_proto.v1.KnowledgeFlagStatus status = 3;
   */
  status: KnowledgeFlagStatus;

  /**
   * 空 = 指定なし
   *
   * @generated from field: string group_key = 4;
   */
  groupKey: string;

  /**
   * 空 = 指定なし。優先度の複数選択（'critical'|'high'|'normal'|'low'|'trivial'）
   *
   * @generated from field: repeated string severities = 5;
   */
  severities: string[];

  /**
   * true ならグループ集計モード（groups を返し flags は空）
   *
   * @generated from field: bool group_mode = 6;
   */
  groupMode: boolean;

  /**
   * 1 始まり。0 は 1 に補正
   *
   * @generated from field: int32 page = 7;
   */
  page: number;

  /**
   * 0 は 50 に補正
   *
   * @generated from field: int32 page_size = 8;
   */
  pageSize: number;

  /**
   * 空 = 指定なし。起票ロット（created_by の完全一致。'import:v1' / 'mcp:review:2026-08-27' 等）
   *
   * @generated from field: string created_by = 9;
   */
  createdBy: string;
};

/**
 * Describes the message api_proto.v1.ListKnowledgeReviewFlagsRequest.
 * Use `create(ListKnowledgeReviewFlagsRequestSchema)` to create a new message.
 */
export const ListKnowledgeReviewFlagsRequestSchema: GenMessage<ListKnowledgeReviewFlagsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 11);

/**
 * グループ集計モードの 1 行
 *
 * @generated from message api_proto.v1.KnowledgeFlagGroup
 */
export type KnowledgeFlagGroup = Message<"api_proto.v1.KnowledgeFlagGroup"> & {
  /**
   * @generated from field: string group_key = 1;
   */
  groupKey: string;

  /**
   * @generated from field: api_proto.v1.KnowledgeFlagCategory category = 2;
   */
  category: KnowledgeFlagCategory;

  /**
   * @generated from field: string document_slug = 3;
   */
  documentSlug: string;

  /**
   * @generated from field: string document_title = 4;
   */
  documentTitle: string;

  /**
   * @generated from field: int32 open_count = 5;
   */
  openCount: number;

  /**
   * 代表フラグの理由（グループの内容感を掴むため）
   *
   * @generated from field: string sample_reason = 6;
   */
  sampleReason: string;

  /**
   * 対象節キーの一部（最大5件）
   *
   * @generated from field: repeated string section_keys = 7;
   */
  sectionKeys: string[];
};

/**
 * Describes the message api_proto.v1.KnowledgeFlagGroup.
 * Use `create(KnowledgeFlagGroupSchema)` to create a new message.
 */
export const KnowledgeFlagGroupSchema: GenMessage<KnowledgeFlagGroup> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 12);

/**
 * @generated from message api_proto.v1.ListKnowledgeReviewFlagsResponse
 */
export type ListKnowledgeReviewFlagsResponse = Message<"api_proto.v1.ListKnowledgeReviewFlagsResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.KnowledgeReviewFlag flags = 1;
   */
  flags: KnowledgeReviewFlag[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;

  /**
   * group_mode=true の場合のみ
   *
   * @generated from field: repeated api_proto.v1.KnowledgeFlagGroup groups = 3;
   */
  groups: KnowledgeFlagGroup[];
};

/**
 * Describes the message api_proto.v1.ListKnowledgeReviewFlagsResponse.
 * Use `create(ListKnowledgeReviewFlagsResponseSchema)` to create a new message.
 */
export const ListKnowledgeReviewFlagsResponseSchema: GenMessage<ListKnowledgeReviewFlagsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 13);

/**
 * 起票する 1 件分。
 * created_by（起票ロット）はサーバーが呼び出し主体から強制セットするため持たない
 *
 * @generated from message api_proto.v1.KnowledgeReviewFlagDraft
 */
export type KnowledgeReviewFlagDraft = Message<"api_proto.v1.KnowledgeReviewFlagDraft"> & {
  /**
   * 対象の節の ID（ULID）
   *
   * @generated from field: string section_id = 1;
   */
  sectionId: string;

  /**
   * @generated from field: api_proto.v1.KnowledgeFlagCategory category = 2;
   */
  category: KnowledgeFlagCategory;

  /**
   * 'critical'|'high'|'normal'|'low'|'trivial'
   *
   * @generated from field: string severity = 3;
   */
  severity: string;

  /**
   * 本文の単一ブロック内からの逐語引用。
   * 正規化後に本文へ部分一致しない場合、その 1 件を含むリクエスト全体を拒否する
   *
   * @generated from field: string quote = 4;
   */
  quote: string;

  /**
   * フラグ理由
   *
   * @generated from field: string reason = 5;
   */
  reason: string;

  /**
   * 監修者への論点（優先度判断の根拠を書く）
   *
   * @generated from field: string review_point = 6;
   */
  reviewPoint: string;
};

/**
 * Describes the message api_proto.v1.KnowledgeReviewFlagDraft.
 * Use `create(KnowledgeReviewFlagDraftSchema)` to create a new message.
 */
export const KnowledgeReviewFlagDraftSchema: GenMessage<KnowledgeReviewFlagDraft> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 14);

/**
 * @generated from message api_proto.v1.CreateKnowledgeReviewFlagsRequest
 */
export type CreateKnowledgeReviewFlagsRequest = Message<"api_proto.v1.CreateKnowledgeReviewFlagsRequest"> & {
  /**
   * 件数上限あり（超過は拒否）
   *
   * @generated from field: repeated api_proto.v1.KnowledgeReviewFlagDraft flags = 1;
   */
  flags: KnowledgeReviewFlagDraft[];
};

/**
 * Describes the message api_proto.v1.CreateKnowledgeReviewFlagsRequest.
 * Use `create(CreateKnowledgeReviewFlagsRequestSchema)` to create a new message.
 */
export const CreateKnowledgeReviewFlagsRequestSchema: GenMessage<CreateKnowledgeReviewFlagsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 15);

/**
 * @generated from message api_proto.v1.CreateKnowledgeReviewFlagsResponse
 */
export type CreateKnowledgeReviewFlagsResponse = Message<"api_proto.v1.CreateKnowledgeReviewFlagsResponse"> & {
  /**
   * 作成した件数
   *
   * @generated from field: int32 created_count = 1;
   */
  createdCount: number;

  /**
   * 同一節・同一観点・正規化後同一引用の未解決フラグが既にありスキップした件数
   *
   * @generated from field: int32 skipped_duplicate_count = 2;
   */
  skippedDuplicateCount: number;

  /**
   * 作成したフラグ（リクエスト順）
   *
   * @generated from field: repeated api_proto.v1.KnowledgeReviewFlag flags = 3;
   */
  flags: KnowledgeReviewFlag[];
};

/**
 * Describes the message api_proto.v1.CreateKnowledgeReviewFlagsResponse.
 * Use `create(CreateKnowledgeReviewFlagsResponseSchema)` to create a new message.
 */
export const CreateKnowledgeReviewFlagsResponseSchema: GenMessage<CreateKnowledgeReviewFlagsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 16);

/**
 * @generated from message api_proto.v1.ListKnowledgeSectionsForReviewRequest
 */
export type ListKnowledgeSectionsForReviewRequest = Message<"api_proto.v1.ListKnowledgeSectionsForReviewRequest"> & {
  /**
   * 空 = 全文書
   *
   * @generated from field: string document_slug = 1;
   */
  documentSlug: string;

  /**
   * UNSPECIFIED = 指定なし。指定した成熟度に達していない節（maturity < この値）だけを返す
   *
   * @generated from field: api_proto.v1.KnowledgeMaturity maturity_below = 2;
   */
  maturityBelow: KnowledgeMaturity;

  /**
   * YYYY-MM-DD。空 = 指定なし。棚卸し期限（review_after）がこの基準日以前の節だけを返す
   *
   * @generated from field: string review_due_on = 3;
   */
  reviewDueOn: string;

  /**
   * true = 未解決フラグを持つ節だけを返す
   *
   * @generated from field: bool has_open_flags = 4;
   */
  hasOpenFlags: boolean;

  /**
   * 1 始まり。0 は 1 に補正
   *
   * @generated from field: int32 page = 5;
   */
  page: number;

  /**
   * 0 は 20 に補正（最大 100）
   *
   * @generated from field: int32 page_size = 6;
   */
  pageSize: number;
};

/**
 * Describes the message api_proto.v1.ListKnowledgeSectionsForReviewRequest.
 * Use `create(ListKnowledgeSectionsForReviewRequestSchema)` to create a new message.
 */
export const ListKnowledgeSectionsForReviewRequestSchema: GenMessage<ListKnowledgeSectionsForReviewRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 17);

/**
 * 再監修対象の 1 節
 *
 * @generated from message api_proto.v1.KnowledgeSectionForReview
 */
export type KnowledgeSectionForReview = Message<"api_proto.v1.KnowledgeSectionForReview"> & {
  /**
   * @generated from field: api_proto.v1.KnowledgeSectionSummary section = 1;
   */
  section?: KnowledgeSectionSummary;

  /**
   * @generated from field: string document_slug = 2;
   */
  documentSlug: string;

  /**
   * @generated from field: string document_title = 3;
   */
  documentTitle: string;

  /**
   * 鮮度（YYYY-MM-DD。空 = 未設定）
   *
   * @generated from field: string as_of = 4;
   */
  asOf: string;

  /**
   * 棚卸し期限（YYYY-MM-DD。空 = 未設定）
   *
   * @generated from field: string review_after = 5;
   */
  reviewAfter: string;
};

/**
 * Describes the message api_proto.v1.KnowledgeSectionForReview.
 * Use `create(KnowledgeSectionForReviewSchema)` to create a new message.
 */
export const KnowledgeSectionForReviewSchema: GenMessage<KnowledgeSectionForReview> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 18);

/**
 * @generated from message api_proto.v1.ListKnowledgeSectionsForReviewResponse
 */
export type ListKnowledgeSectionsForReviewResponse = Message<"api_proto.v1.ListKnowledgeSectionsForReviewResponse"> & {
  /**
   * 既定は review_after 昇順（未設定は末尾）
   *
   * @generated from field: repeated api_proto.v1.KnowledgeSectionForReview sections = 1;
   */
  sections: KnowledgeSectionForReview[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message api_proto.v1.ListKnowledgeSectionsForReviewResponse.
 * Use `create(ListKnowledgeSectionsForReviewResponseSchema)` to create a new message.
 */
export const ListKnowledgeSectionsForReviewResponseSchema: GenMessage<ListKnowledgeSectionsForReviewResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 19);

/**
 * @generated from message api_proto.v1.ResolveKnowledgeReviewFlagRequest
 */
export type ResolveKnowledgeReviewFlagRequest = Message<"api_proto.v1.ResolveKnowledgeReviewFlagRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * APPROVED / DISMISSED のみ許可（EDITED は UpdateKnowledgeSection 経由）
   *
   * @generated from field: api_proto.v1.KnowledgeFlagStatus verdict = 2;
   */
  verdict: KnowledgeFlagStatus;

  /**
   * メモ（判断前でも記入できる。判断時の記録を兼ねる）
   *
   * @generated from field: string resolution_note = 3;
   */
  resolutionNote: string;
};

/**
 * Describes the message api_proto.v1.ResolveKnowledgeReviewFlagRequest.
 * Use `create(ResolveKnowledgeReviewFlagRequestSchema)` to create a new message.
 */
export const ResolveKnowledgeReviewFlagRequestSchema: GenMessage<ResolveKnowledgeReviewFlagRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 20);

/**
 * 判断とは独立にフラグのメモだけを保存する（判断前でも残せる）
 *
 * @generated from message api_proto.v1.UpdateKnowledgeReviewFlagNoteRequest
 */
export type UpdateKnowledgeReviewFlagNoteRequest = Message<"api_proto.v1.UpdateKnowledgeReviewFlagNoteRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * メモ（判断前でも記入できる。判断時の記録を兼ねる）。空文字でクリアできる
   *
   * @generated from field: string resolution_note = 2;
   */
  resolutionNote: string;
};

/**
 * Describes the message api_proto.v1.UpdateKnowledgeReviewFlagNoteRequest.
 * Use `create(UpdateKnowledgeReviewFlagNoteRequestSchema)` to create a new message.
 */
export const UpdateKnowledgeReviewFlagNoteRequestSchema: GenMessage<UpdateKnowledgeReviewFlagNoteRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 21);

/**
 * @generated from message api_proto.v1.UpdateKnowledgeReviewFlagNoteResponse
 */
export type UpdateKnowledgeReviewFlagNoteResponse = Message<"api_proto.v1.UpdateKnowledgeReviewFlagNoteResponse"> & {
  /**
   * @generated from field: api_proto.v1.KnowledgeReviewFlag flag = 1;
   */
  flag?: KnowledgeReviewFlag;
};

/**
 * Describes the message api_proto.v1.UpdateKnowledgeReviewFlagNoteResponse.
 * Use `create(UpdateKnowledgeReviewFlagNoteResponseSchema)` to create a new message.
 */
export const UpdateKnowledgeReviewFlagNoteResponseSchema: GenMessage<UpdateKnowledgeReviewFlagNoteResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 22);

/**
 * @generated from message api_proto.v1.ResolveKnowledgeReviewFlagResponse
 */
export type ResolveKnowledgeReviewFlagResponse = Message<"api_proto.v1.ResolveKnowledgeReviewFlagResponse"> & {
  /**
   * @generated from field: api_proto.v1.KnowledgeReviewFlag flag = 1;
   */
  flag?: KnowledgeReviewFlag;
};

/**
 * Describes the message api_proto.v1.ResolveKnowledgeReviewFlagResponse.
 * Use `create(ResolveKnowledgeReviewFlagResponseSchema)` to create a new message.
 */
export const ResolveKnowledgeReviewFlagResponseSchema: GenMessage<ResolveKnowledgeReviewFlagResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 23);

/**
 * @generated from message api_proto.v1.BulkResolveKnowledgeReviewFlagsRequest
 */
export type BulkResolveKnowledgeReviewFlagsRequest = Message<"api_proto.v1.BulkResolveKnowledgeReviewFlagsRequest"> & {
  /**
   * ids か group_key のどちらか一方を指定
   *
   * @generated from field: repeated string ids = 1;
   */
  ids: string[];

  /**
   * @generated from field: string group_key = 2;
   */
  groupKey: string;

  /**
   * APPROVED / DISMISSED のみ許可
   *
   * @generated from field: api_proto.v1.KnowledgeFlagStatus verdict = 3;
   */
  verdict: KnowledgeFlagStatus;

  /**
   * メモ（判断前でも記入できる。判断時の記録を兼ねる）
   *
   * @generated from field: string resolution_note = 4;
   */
  resolutionNote: string;
};

/**
 * Describes the message api_proto.v1.BulkResolveKnowledgeReviewFlagsRequest.
 * Use `create(BulkResolveKnowledgeReviewFlagsRequestSchema)` to create a new message.
 */
export const BulkResolveKnowledgeReviewFlagsRequestSchema: GenMessage<BulkResolveKnowledgeReviewFlagsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 24);

/**
 * @generated from message api_proto.v1.BulkResolveKnowledgeReviewFlagsResponse
 */
export type BulkResolveKnowledgeReviewFlagsResponse = Message<"api_proto.v1.BulkResolveKnowledgeReviewFlagsResponse"> & {
  /**
   * @generated from field: int32 resolved_count = 1;
   */
  resolvedCount: number;
};

/**
 * Describes the message api_proto.v1.BulkResolveKnowledgeReviewFlagsResponse.
 * Use `create(BulkResolveKnowledgeReviewFlagsResponseSchema)` to create a new message.
 */
export const BulkResolveKnowledgeReviewFlagsResponseSchema: GenMessage<BulkResolveKnowledgeReviewFlagsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 25);

/**
 * @generated from message api_proto.v1.ListKnowledgeDocumentsRequest
 */
export type ListKnowledgeDocumentsRequest = Message<"api_proto.v1.ListKnowledgeDocumentsRequest"> & {
};

/**
 * Describes the message api_proto.v1.ListKnowledgeDocumentsRequest.
 * Use `create(ListKnowledgeDocumentsRequestSchema)` to create a new message.
 */
export const ListKnowledgeDocumentsRequestSchema: GenMessage<ListKnowledgeDocumentsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 26);

/**
 * @generated from message api_proto.v1.ListKnowledgeDocumentsResponse
 */
export type ListKnowledgeDocumentsResponse = Message<"api_proto.v1.ListKnowledgeDocumentsResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.KnowledgeDocumentSummary documents = 1;
   */
  documents: KnowledgeDocumentSummary[];
};

/**
 * Describes the message api_proto.v1.ListKnowledgeDocumentsResponse.
 * Use `create(ListKnowledgeDocumentsResponseSchema)` to create a new message.
 */
export const ListKnowledgeDocumentsResponseSchema: GenMessage<ListKnowledgeDocumentsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 27);

/**
 * @generated from message api_proto.v1.GetKnowledgeDocumentRequest
 */
export type GetKnowledgeDocumentRequest = Message<"api_proto.v1.GetKnowledgeDocumentRequest"> & {
  /**
   * @generated from field: string slug = 1;
   */
  slug: string;
};

/**
 * Describes the message api_proto.v1.GetKnowledgeDocumentRequest.
 * Use `create(GetKnowledgeDocumentRequestSchema)` to create a new message.
 */
export const GetKnowledgeDocumentRequestSchema: GenMessage<GetKnowledgeDocumentRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 28);

/**
 * @generated from message api_proto.v1.GetKnowledgeDocumentResponse
 */
export type GetKnowledgeDocumentResponse = Message<"api_proto.v1.GetKnowledgeDocumentResponse"> & {
  /**
   * @generated from field: api_proto.v1.KnowledgeDocumentSummary document = 1;
   */
  document?: KnowledgeDocumentSummary;

  /**
   * seq 昇順（superseded を含む。UI 側でフィルタ）
   *
   * @generated from field: repeated api_proto.v1.KnowledgeSectionSummary sections = 2;
   */
  sections: KnowledgeSectionSummary[];
};

/**
 * Describes the message api_proto.v1.GetKnowledgeDocumentResponse.
 * Use `create(GetKnowledgeDocumentResponseSchema)` to create a new message.
 */
export const GetKnowledgeDocumentResponseSchema: GenMessage<GetKnowledgeDocumentResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 29);

/**
 * @generated from message api_proto.v1.CreateKnowledgeDocumentRequest
 */
export type CreateKnowledgeDocumentRequest = Message<"api_proto.v1.CreateKnowledgeDocumentRequest"> & {
  /**
   * knowledge_domains.domain_key（未存在は InvalidArgument）
   *
   * @generated from field: string domain_key = 1;
   */
  domainKey: string;

  /**
   * 'roof-materials' 等。`^[a-z0-9-]{3,60}$`。重複は KNOWLEDGE_DOCUMENT_SLUG_TAKEN
   *
   * @generated from field: string slug = 2;
   */
  slug: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;
};

/**
 * Describes the message api_proto.v1.CreateKnowledgeDocumentRequest.
 * Use `create(CreateKnowledgeDocumentRequestSchema)` to create a new message.
 */
export const CreateKnowledgeDocumentRequestSchema: GenMessage<CreateKnowledgeDocumentRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 30);

/**
 * @generated from message api_proto.v1.CreateKnowledgeDocumentResponse
 */
export type CreateKnowledgeDocumentResponse = Message<"api_proto.v1.CreateKnowledgeDocumentResponse"> & {
  /**
   * 節は 1 件も作られない（前文概念は廃止。文書の前提は premise が持つ）
   *
   * @generated from field: api_proto.v1.KnowledgeDocumentSummary document = 1;
   */
  document?: KnowledgeDocumentSummary;
};

/**
 * Describes the message api_proto.v1.CreateKnowledgeDocumentResponse.
 * Use `create(CreateKnowledgeDocumentResponseSchema)` to create a new message.
 */
export const CreateKnowledgeDocumentResponseSchema: GenMessage<CreateKnowledgeDocumentResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 31);

/**
 * @generated from message api_proto.v1.UpdateKnowledgeDocumentRequest
 */
export type UpdateKnowledgeDocumentRequest = Message<"api_proto.v1.UpdateKnowledgeDocumentRequest"> & {
  /**
   * ULID
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 文書名（必須）
   *
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * 前提・免責（空可 = 未設定に戻す）
   *
   * @generated from field: string premise = 3;
   */
  premise: string;
};

/**
 * Describes the message api_proto.v1.UpdateKnowledgeDocumentRequest.
 * Use `create(UpdateKnowledgeDocumentRequestSchema)` to create a new message.
 */
export const UpdateKnowledgeDocumentRequestSchema: GenMessage<UpdateKnowledgeDocumentRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 32);

/**
 * @generated from message api_proto.v1.UpdateKnowledgeDocumentResponse
 */
export type UpdateKnowledgeDocumentResponse = Message<"api_proto.v1.UpdateKnowledgeDocumentResponse"> & {
  /**
   * @generated from field: api_proto.v1.KnowledgeDocumentSummary document = 1;
   */
  document?: KnowledgeDocumentSummary;
};

/**
 * Describes the message api_proto.v1.UpdateKnowledgeDocumentResponse.
 * Use `create(UpdateKnowledgeDocumentResponseSchema)` to create a new message.
 */
export const UpdateKnowledgeDocumentResponseSchema: GenMessage<UpdateKnowledgeDocumentResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 33);

/**
 * @generated from message api_proto.v1.GetKnowledgeSectionRequest
 */
export type GetKnowledgeSectionRequest = Message<"api_proto.v1.GetKnowledgeSectionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message api_proto.v1.GetKnowledgeSectionRequest.
 * Use `create(GetKnowledgeSectionRequestSchema)` to create a new message.
 */
export const GetKnowledgeSectionRequestSchema: GenMessage<GetKnowledgeSectionRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 34);

/**
 * @generated from message api_proto.v1.GetKnowledgeSectionResponse
 */
export type GetKnowledgeSectionResponse = Message<"api_proto.v1.GetKnowledgeSectionResponse"> & {
  /**
   * @generated from field: api_proto.v1.KnowledgeSection section = 1;
   */
  section?: KnowledgeSection;

  /**
   * open 状態のフラグのみ
   *
   * @generated from field: repeated api_proto.v1.KnowledgeReviewFlag open_flags = 2;
   */
  openFlags: KnowledgeReviewFlag[];
};

/**
 * Describes the message api_proto.v1.GetKnowledgeSectionResponse.
 * Use `create(GetKnowledgeSectionResponseSchema)` to create a new message.
 */
export const GetKnowledgeSectionResponseSchema: GenMessage<GetKnowledgeSectionResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 35);

/**
 * @generated from message api_proto.v1.CreateKnowledgeSectionRequest
 */
export type CreateKnowledgeSectionRequest = Message<"api_proto.v1.CreateKnowledgeSectionRequest"> & {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId: string;

  /**
   * 既存章の番号（章の末尾に追加され、section_key はサーバーが自動採番）
   *
   * @generated from field: int32 chapter_no = 2;
   */
  chapterNo: number;

  /**
   * @generated from field: string heading = 3;
   */
  heading: string;

  /**
   * 'definition'|'procedure'|... テンプレ型ならテンプレ H4 雛形を body に自動挿入
   *
   * @generated from field: string content_type = 4;
   */
  contentType: string;
};

/**
 * Describes the message api_proto.v1.CreateKnowledgeSectionRequest.
 * Use `create(CreateKnowledgeSectionRequestSchema)` to create a new message.
 */
export const CreateKnowledgeSectionRequestSchema: GenMessage<CreateKnowledgeSectionRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 36);

/**
 * @generated from message api_proto.v1.CreateKnowledgeSectionResponse
 */
export type CreateKnowledgeSectionResponse = Message<"api_proto.v1.CreateKnowledgeSectionResponse"> & {
  /**
   * @generated from field: api_proto.v1.KnowledgeSection section = 1;
   */
  section?: KnowledgeSection;
};

/**
 * Describes the message api_proto.v1.CreateKnowledgeSectionResponse.
 * Use `create(CreateKnowledgeSectionResponseSchema)` to create a new message.
 */
export const CreateKnowledgeSectionResponseSchema: GenMessage<CreateKnowledgeSectionResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 37);

/**
 * @generated from message api_proto.v1.CreateKnowledgeChapterRequest
 */
export type CreateKnowledgeChapterRequest = Message<"api_proto.v1.CreateKnowledgeChapterRequest"> & {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId: string;

  /**
   * 章見出し。章番号は文書内既存最大 chapter_no（superseded 含む）+ 1 をサーバーが自動採番
   *
   * @generated from field: string heading = 2;
   */
  heading: string;
};

/**
 * Describes the message api_proto.v1.CreateKnowledgeChapterRequest.
 * Use `create(CreateKnowledgeChapterRequestSchema)` to create a new message.
 */
export const CreateKnowledgeChapterRequestSchema: GenMessage<CreateKnowledgeChapterRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 38);

/**
 * @generated from message api_proto.v1.CreateKnowledgeChapterResponse
 */
export type CreateKnowledgeChapterResponse = Message<"api_proto.v1.CreateKnowledgeChapterResponse"> & {
  /**
   * 新設章の章見出し節（section_key = 章番号の文字列表現）
   *
   * @generated from field: api_proto.v1.KnowledgeSection section = 1;
   */
  section?: KnowledgeSection;
};

/**
 * Describes the message api_proto.v1.CreateKnowledgeChapterResponse.
 * Use `create(CreateKnowledgeChapterResponseSchema)` to create a new message.
 */
export const CreateKnowledgeChapterResponseSchema: GenMessage<CreateKnowledgeChapterResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 39);

/**
 * @generated from message api_proto.v1.UpdateKnowledgeSectionRequest
 */
export type UpdateKnowledgeSectionRequest = Message<"api_proto.v1.UpdateKnowledgeSectionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 楽観ロック: 現在の revision_no と一致しない場合はエラー（KNOWLEDGE_SECTION_CONFLICT）
   *
   * @generated from field: int32 base_revision_no = 2;
   */
  baseRevisionNo: number;

  /**
   * @generated from field: string heading = 3;
   */
  heading: string;

  /**
   * @generated from field: string body = 4;
   */
  body: string;

  /**
   * @generated from field: string content_type = 5;
   */
  contentType: string;

  /**
   * 日本語の自由記述。旧・内部英語コード（judgment_basis / self_check）はサーバー側で日本語へ正規化される
   *
   * @generated from field: string usage_context = 6;
   */
  usageContext: string;

  /**
   * @generated from field: api_proto.v1.KnowledgeMaturity maturity = 7;
   */
  maturity: KnowledgeMaturity;

  /**
   * YYYY-MM-DD。空 = 未設定
   *
   * @generated from field: string as_of = 8;
   */
  asOf: string;

  /**
   * @generated from field: string review_after = 9;
   */
  reviewAfter: string;

  /**
   * @generated from field: string change_reason = 10;
   */
  changeReason: string;

  /**
   * 指定時、該当フラグを EDITED に自動遷移させる
   *
   * @generated from field: string origin_flag_id = 11;
   */
  originFlagId: string;

  /**
   * 出典種別 'kyokasho'|'research'|'contribution'|'internal'。
   * 他項目と違い未指定（nil）は「現在値を維持」を意味する。既存クライアント（Admin 画面の
   * 節編集フォーム）はこの 2 項目を送らないため、空 = 未設定とすると保存のたびに
   * インポート済みの出典情報が消える。値を変えるときだけ明示的に指定する。
   *
   * @generated from field: optional string source_type = 12;
   */
  sourceType?: string;

  /**
   * 原典ページ（'p.023' 等・32 文字以内）。空文字を指定すると未設定に戻す。
   * 未指定（nil）は source_type と同じく「現在値を維持」。
   *
   * @generated from field: optional string source_page = 13;
   */
  sourcePage?: string;
};

/**
 * Describes the message api_proto.v1.UpdateKnowledgeSectionRequest.
 * Use `create(UpdateKnowledgeSectionRequestSchema)` to create a new message.
 */
export const UpdateKnowledgeSectionRequestSchema: GenMessage<UpdateKnowledgeSectionRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 40);

/**
 * @generated from message api_proto.v1.UpdateKnowledgeSectionResponse
 */
export type UpdateKnowledgeSectionResponse = Message<"api_proto.v1.UpdateKnowledgeSectionResponse"> & {
  /**
   * @generated from field: api_proto.v1.KnowledgeSection section = 1;
   */
  section?: KnowledgeSection;
};

/**
 * Describes the message api_proto.v1.UpdateKnowledgeSectionResponse.
 * Use `create(UpdateKnowledgeSectionResponseSchema)` to create a new message.
 */
export const UpdateKnowledgeSectionResponseSchema: GenMessage<UpdateKnowledgeSectionResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 41);

/**
 * @generated from message api_proto.v1.SupersedeKnowledgeSectionRequest
 */
export type SupersedeKnowledgeSectionRequest = Message<"api_proto.v1.SupersedeKnowledgeSectionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * Describes the message api_proto.v1.SupersedeKnowledgeSectionRequest.
 * Use `create(SupersedeKnowledgeSectionRequestSchema)` to create a new message.
 */
export const SupersedeKnowledgeSectionRequestSchema: GenMessage<SupersedeKnowledgeSectionRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 42);

/**
 * @generated from message api_proto.v1.SupersedeKnowledgeSectionResponse
 */
export type SupersedeKnowledgeSectionResponse = Message<"api_proto.v1.SupersedeKnowledgeSectionResponse"> & {
};

/**
 * Describes the message api_proto.v1.SupersedeKnowledgeSectionResponse.
 * Use `create(SupersedeKnowledgeSectionResponseSchema)` to create a new message.
 */
export const SupersedeKnowledgeSectionResponseSchema: GenMessage<SupersedeKnowledgeSectionResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 43);

/**
 * @generated from message api_proto.v1.ListKnowledgeSectionRevisionsRequest
 */
export type ListKnowledgeSectionRevisionsRequest = Message<"api_proto.v1.ListKnowledgeSectionRevisionsRequest"> & {
  /**
   * @generated from field: string section_id = 1;
   */
  sectionId: string;
};

/**
 * Describes the message api_proto.v1.ListKnowledgeSectionRevisionsRequest.
 * Use `create(ListKnowledgeSectionRevisionsRequestSchema)` to create a new message.
 */
export const ListKnowledgeSectionRevisionsRequestSchema: GenMessage<ListKnowledgeSectionRevisionsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 44);

/**
 * @generated from message api_proto.v1.ListKnowledgeSectionRevisionsResponse
 */
export type ListKnowledgeSectionRevisionsResponse = Message<"api_proto.v1.ListKnowledgeSectionRevisionsResponse"> & {
  /**
   * revision_no 降順
   *
   * @generated from field: repeated api_proto.v1.KnowledgeSectionRevision revisions = 1;
   */
  revisions: KnowledgeSectionRevision[];
};

/**
 * Describes the message api_proto.v1.ListKnowledgeSectionRevisionsResponse.
 * Use `create(ListKnowledgeSectionRevisionsResponseSchema)` to create a new message.
 */
export const ListKnowledgeSectionRevisionsResponseSchema: GenMessage<ListKnowledgeSectionRevisionsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 45);

/**
 * @generated from message api_proto.v1.RevertKnowledgeSectionRequest
 */
export type RevertKnowledgeSectionRequest = Message<"api_proto.v1.RevertKnowledgeSectionRequest"> & {
  /**
   * @generated from field: string section_id = 1;
   */
  sectionId: string;

  /**
   * この版の内容で新しい revision を発行する（履歴は消えない）
   *
   * @generated from field: int32 to_revision_no = 2;
   */
  toRevisionNo: number;

  /**
   * 楽観ロック
   *
   * @generated from field: int32 base_revision_no = 3;
   */
  baseRevisionNo: number;
};

/**
 * Describes the message api_proto.v1.RevertKnowledgeSectionRequest.
 * Use `create(RevertKnowledgeSectionRequestSchema)` to create a new message.
 */
export const RevertKnowledgeSectionRequestSchema: GenMessage<RevertKnowledgeSectionRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 46);

/**
 * @generated from message api_proto.v1.RevertKnowledgeSectionResponse
 */
export type RevertKnowledgeSectionResponse = Message<"api_proto.v1.RevertKnowledgeSectionResponse"> & {
  /**
   * @generated from field: api_proto.v1.KnowledgeSection section = 1;
   */
  section?: KnowledgeSection;
};

/**
 * Describes the message api_proto.v1.RevertKnowledgeSectionResponse.
 * Use `create(RevertKnowledgeSectionResponseSchema)` to create a new message.
 */
export const RevertKnowledgeSectionResponseSchema: GenMessage<RevertKnowledgeSectionResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 47);

/**
 * 並び替え後の 1 章分（章見出し節 + 配下の節を表示順に並べたもの）
 *
 * @generated from message api_proto.v1.ReorderedChapter
 */
export type ReorderedChapter = Message<"api_proto.v1.ReorderedChapter"> & {
  /**
   * 章見出し節（section_key が章番号だけの節）の id（ULID）
   *
   * @generated from field: string chapter_section_id = 1;
   */
  chapterSectionId: string;

  /**
   * 章配下の節の id（ULID）を表示順に並べたもの。章見出し節自身は含めない
   *
   * @generated from field: repeated string section_ids = 2;
   */
  sectionIds: string[];
};

/**
 * Describes the message api_proto.v1.ReorderedChapter.
 * Use `create(ReorderedChapterSchema)` to create a new message.
 */
export const ReorderedChapterSchema: GenMessage<ReorderedChapter> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 48);

/**
 * @generated from message api_proto.v1.ReorderKnowledgeSectionsRequest
 */
export type ReorderKnowledgeSectionsRequest = Message<"api_proto.v1.ReorderKnowledgeSectionsRequest"> & {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId: string;

  /**
   * 配列順に chapter_no を 1..N、seq を文書内通し番号 1..M で再採番する。
   * 文書配下の全節（SUPERSEDED を含む）を過不足なく含めること。
   * section_key と本文は書き換えない（並び替えで版は発行されない）
   *
   * @generated from field: repeated api_proto.v1.ReorderedChapter chapters = 2;
   */
  chapters: ReorderedChapter[];

  /**
   * 競合検知用。クライアントが読んだ時点の順序（seq 昇順の節 id 全件）。
   * 現在の順序と一致しない場合は更新せず KNOWLEDGE_SECTION_ORDER_CONFLICT を返す
   *
   * @generated from field: repeated string expected_section_ids = 3;
   */
  expectedSectionIds: string[];
};

/**
 * Describes the message api_proto.v1.ReorderKnowledgeSectionsRequest.
 * Use `create(ReorderKnowledgeSectionsRequestSchema)` to create a new message.
 */
export const ReorderKnowledgeSectionsRequestSchema: GenMessage<ReorderKnowledgeSectionsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 49);

/**
 * @generated from message api_proto.v1.ReorderKnowledgeSectionsResponse
 */
export type ReorderKnowledgeSectionsResponse = Message<"api_proto.v1.ReorderKnowledgeSectionsResponse"> & {
  /**
   * 並び替え後の節一覧（seq 昇順・SUPERSEDED 含む）
   *
   * @generated from field: repeated api_proto.v1.KnowledgeSectionSummary sections = 1;
   */
  sections: KnowledgeSectionSummary[];
};

/**
 * Describes the message api_proto.v1.ReorderKnowledgeSectionsResponse.
 * Use `create(ReorderKnowledgeSectionsResponseSchema)` to create a new message.
 */
export const ReorderKnowledgeSectionsResponseSchema: GenMessage<ReorderKnowledgeSectionsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 50);

/**
 * @generated from message api_proto.v1.SearchKnowledgePreviewRequest
 */
export type SearchKnowledgePreviewRequest = Message<"api_proto.v1.SearchKnowledgePreviewRequest"> & {
  /**
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * 空 = 全文書
   *
   * @generated from field: string document_slug = 2;
   */
  documentSlug: string;

  /**
   * 0 は 10 に補正（最大 50）
   *
   * @generated from field: int32 limit = 3;
   */
  limit: number;
};

/**
 * Describes the message api_proto.v1.SearchKnowledgePreviewRequest.
 * Use `create(SearchKnowledgePreviewRequestSchema)` to create a new message.
 */
export const SearchKnowledgePreviewRequestSchema: GenMessage<SearchKnowledgePreviewRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 51);

/**
 * 検索プレビューの 1 件
 *
 * @generated from message api_proto.v1.KnowledgeSearchHit
 */
export type KnowledgeSearchHit = Message<"api_proto.v1.KnowledgeSearchHit"> & {
  /**
   * @generated from field: string section_id = 1;
   */
  sectionId: string;

  /**
   * @generated from field: string document_slug = 2;
   */
  documentSlug: string;

  /**
   * @generated from field: string document_title = 3;
   */
  documentTitle: string;

  /**
   * @generated from field: string section_key = 4;
   */
  sectionKey: string;

  /**
   * @generated from field: string heading = 5;
   */
  heading: string;

  /**
   * @generated from field: string breadcrumb = 6;
   */
  breadcrumb: string;

  /**
   * 本文冒頭の抜粋（最大200文字程度）
   *
   * @generated from field: string snippet = 7;
   */
  snippet: string;

  /**
   * ngram FULLTEXT の関連度スコア
   *
   * @generated from field: double score = 8;
   */
  score: number;

  /**
   * ヒットした節の成熟度（この回答根拠が監修済みかを検索プレビューで示す計器）
   *
   * @generated from field: api_proto.v1.KnowledgeMaturity maturity = 9;
   */
  maturity: KnowledgeMaturity;

  /**
   * ヒットした節に残る未判断（OPEN）フラグ数
   *
   * @generated from field: int32 open_flag_count = 10;
   */
  openFlagCount: number;

  /**
   * ハイブリッド検索時にマッチしたチャンク番号（節内 1 始まり。lexical フォールバック時は 0）
   *
   * @generated from field: int32 matched_chunk_no = 11;
   */
  matchedChunkNo: number;
};

/**
 * Describes the message api_proto.v1.KnowledgeSearchHit.
 * Use `create(KnowledgeSearchHitSchema)` to create a new message.
 */
export const KnowledgeSearchHitSchema: GenMessage<KnowledgeSearchHit> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 52);

/**
 * @generated from message api_proto.v1.SearchKnowledgePreviewResponse
 */
export type SearchKnowledgePreviewResponse = Message<"api_proto.v1.SearchKnowledgePreviewResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.KnowledgeSearchHit hits = 1;
   */
  hits: KnowledgeSearchHit[];

  /**
   * 実行された検索モード: "hybrid"（dense+lexical RRF）| "lexical"（FULLTEXT のみ・degraded 含む）
   * lexical になる 4 条件（うち document_slug 指定は degraded ではない）と RRF の仕様:
   * doc/architecture/knowledge-rag.md
   *
   * @generated from field: string search_mode = 2;
   */
  searchMode: string;
};

/**
 * Describes the message api_proto.v1.SearchKnowledgePreviewResponse.
 * Use `create(SearchKnowledgePreviewResponseSchema)` to create a new message.
 */
export const SearchKnowledgePreviewResponseSchema: GenMessage<SearchKnowledgePreviewResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 53);

/**
 * @generated from message api_proto.v1.ExportKnowledgeMarkdownRequest
 */
export type ExportKnowledgeMarkdownRequest = Message<"api_proto.v1.ExportKnowledgeMarkdownRequest"> & {
  /**
   * 空 = 全文書
   *
   * @generated from field: string document_slug = 1;
   */
  documentSlug: string;
};

/**
 * Describes the message api_proto.v1.ExportKnowledgeMarkdownRequest.
 * Use `create(ExportKnowledgeMarkdownRequestSchema)` to create a new message.
 */
export const ExportKnowledgeMarkdownRequestSchema: GenMessage<ExportKnowledgeMarkdownRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 54);

/**
 * エクスポートされた md ファイル
 *
 * @generated from message api_proto.v1.KnowledgeMarkdownFile
 */
export type KnowledgeMarkdownFile = Message<"api_proto.v1.KnowledgeMarkdownFile"> & {
  /**
   * @generated from field: string slug = 1;
   */
  slug: string;

  /**
   * 'roof-materials.md' 等
   *
   * @generated from field: string filename = 2;
   */
  filename: string;

  /**
   * @generated from field: string content = 3;
   */
  content: string;
};

/**
 * Describes the message api_proto.v1.KnowledgeMarkdownFile.
 * Use `create(KnowledgeMarkdownFileSchema)` to create a new message.
 */
export const KnowledgeMarkdownFileSchema: GenMessage<KnowledgeMarkdownFile> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 55);

/**
 * @generated from message api_proto.v1.ExportKnowledgeMarkdownResponse
 */
export type ExportKnowledgeMarkdownResponse = Message<"api_proto.v1.ExportKnowledgeMarkdownResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.KnowledgeMarkdownFile files = 1;
   */
  files: KnowledgeMarkdownFile[];
};

/**
 * Describes the message api_proto.v1.ExportKnowledgeMarkdownResponse.
 * Use `create(ExportKnowledgeMarkdownResponseSchema)` to create a new message.
 */
export const ExportKnowledgeMarkdownResponseSchema: GenMessage<ExportKnowledgeMarkdownResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_knowledge, 56);

/**
 * 知識のスコープ
 *
 * @generated from enum api_proto.v1.KnowledgeScope
 */
export enum KnowledgeScope {
  /**
   * @generated from enum value: KNOWLEDGE_SCOPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 全社共有の業界知識
   *
   * @generated from enum value: KNOWLEDGE_SCOPE_GLOBAL = 1;
   */
  GLOBAL = 1,

  /**
   * テナント（企業）私有知識（第一次では未使用）
   *
   * @generated from enum value: KNOWLEDGE_SCOPE_TENANT = 2;
   */
  TENANT = 2,
}

/**
 * Describes the enum api_proto.v1.KnowledgeScope.
 */
export const KnowledgeScopeSchema: GenEnum<KnowledgeScope> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_knowledge, 0);

/**
 * 節の公開状態
 *
 * @generated from enum api_proto.v1.KnowledgeSectionStatus
 */
export enum KnowledgeSectionStatus {
  /**
   * @generated from enum value: KNOWLEDGE_SECTION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 未確定（検索対象外）
   *
   * @generated from enum value: KNOWLEDGE_SECTION_STATUS_DRAFT = 1;
   */
  DRAFT = 1,

  /**
   * 有効（検索対象）
   *
   * @generated from enum value: KNOWLEDGE_SECTION_STATUS_ACTIVE = 2;
   */
  ACTIVE = 2,

  /**
   * 論理削除（永久欠番。物理削除は存在しない）
   *
   * @generated from enum value: KNOWLEDGE_SECTION_STATUS_SUPERSEDED = 3;
   */
  SUPERSEDED = 3,
}

/**
 * Describes the enum api_proto.v1.KnowledgeSectionStatus.
 */
export const KnowledgeSectionStatusSchema: GenEnum<KnowledgeSectionStatus> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_knowledge, 1);

/**
 * 節の知識成熟度（旧 md の status マーカー相当。ダッシュボード集計軸）
 *
 * @generated from enum api_proto.v1.KnowledgeMaturity
 */
export enum KnowledgeMaturity {
  /**
   * @generated from enum value: KNOWLEDGE_MATURITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 未執筆（意図的な空欄含む）
   *
   * @generated from enum value: KNOWLEDGE_MATURITY_EMPTY = 1;
   */
  EMPTY = 1,

  /**
   * 『屋根の教科書』由来（言い換え済み）
   *
   * @generated from enum value: KNOWLEDGE_MATURITY_FROM_KYOKASHO = 2;
   */
  FROM_KYOKASHO = 2,

  /**
   * Web リサーチ済み（出典付き）
   *
   * @generated from enum value: KNOWLEDGE_MATURITY_RESEARCHED = 3;
   */
  RESEARCHED = 3,

  /**
   * 一次資料との突合まで完了
   *
   * @generated from enum value: KNOWLEDGE_MATURITY_VERIFIED = 4;
   */
  VERIFIED = 4,
}

/**
 * Describes the enum api_proto.v1.KnowledgeMaturity.
 */
export const KnowledgeMaturitySchema: GenEnum<KnowledgeMaturity> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_knowledge, 2);

/**
 * 知識ユニットの粒度（文書タイプによって H3 が単位だったり H2 が単位だったりする事実の表現）
 * 設計 SSOT: knowledge-admin-redesign-2026-08-13.md §2
 *
 * @generated from enum api_proto.v1.KnowledgeGranularity
 */
export enum KnowledgeGranularity {
  /**
   * @generated from enum value: KNOWLEDGE_GRANULARITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 節（H3）が知識ユニット。素材・工法・診断など大半の文書
   *
   * @generated from enum value: KNOWLEDGE_GRANULARITY_SECTION = 1;
   */
  SECTION = 1,

  /**
   * 章（H2）が知識ユニット。用語集・事例集のように H3 節を持たない文書
   *
   * @generated from enum value: KNOWLEDGE_GRANULARITY_CHAPTER = 2;
   */
  CHAPTER = 2,
}

/**
 * Describes the enum api_proto.v1.KnowledgeGranularity.
 */
export const KnowledgeGranularitySchema: GenEnum<KnowledgeGranularity> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_knowledge, 3);

/**
 * 要監修フラグの分類（監修パッケージの A〜G に対応）
 *
 * @generated from enum api_proto.v1.KnowledgeFlagCategory
 */
export enum KnowledgeFlagCategory {
  /**
   * @generated from enum value: KNOWLEDGE_FLAG_CATEGORY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * A: 教科書と一次資料の相違
   *
   * @generated from enum value: KNOWLEDGE_FLAG_CATEGORY_SOURCE_CONFLICT = 1;
   */
  SOURCE_CONFLICT = 1,

  /**
   * B: 出典間の相違・両論併記
   *
   * @generated from enum value: KNOWLEDGE_FLAG_CATEGORY_ORIGIN_CONFLICT = 2;
   */
  ORIGIN_CONFLICT = 2,

  /**
   * C: 文書間の相違
   *
   * @generated from enum value: KNOWLEDGE_FLAG_CATEGORY_DOC_CONFLICT = 3;
   */
  DOC_CONFLICT = 3,

  /**
   * D: 法解釈・制度の当てはめ
   *
   * @generated from enum value: KNOWLEDGE_FLAG_CATEGORY_LEGAL = 4;
   */
  LEGAL = 4,

  /**
   * E: 価格の実勢補正
   *
   * @generated from enum value: KNOWLEDGE_FLAG_CATEGORY_PRICE_CALIBRATION = 5;
   */
  PRICE_CALIBRATION = 5,

  /**
   * F: 二次情報のみ
   *
   * @generated from enum value: KNOWLEDGE_FLAG_CATEGORY_SECONDARY_ONLY = 6;
   */
  SECONDARY_ONLY = 6,

  /**
   * G: 現場感の確認・自社知見の追記依頼
   *
   * @generated from enum value: KNOWLEDGE_FLAG_CATEGORY_FIELD_CHECK = 7;
   */
  FIELD_CHECK = 7,

  /**
   * 鮮度棚卸し（自動発行・第一次では未使用）
   *
   * @generated from enum value: KNOWLEDGE_FLAG_CATEGORY_FRESHNESS = 8;
   */
  FRESHNESS = 8,

  /**
   * その他
   *
   * @generated from enum value: KNOWLEDGE_FLAG_CATEGORY_OTHER = 9;
   */
  OTHER = 9,
}

/**
 * Describes the enum api_proto.v1.KnowledgeFlagCategory.
 */
export const KnowledgeFlagCategorySchema: GenEnum<KnowledgeFlagCategory> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_knowledge, 4);

/**
 * 要監修フラグの状態
 *
 * @generated from enum api_proto.v1.KnowledgeFlagStatus
 */
export enum KnowledgeFlagStatus {
  /**
   * @generated from enum value: KNOWLEDGE_FLAG_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 未判断
   *
   * @generated from enum value: KNOWLEDGE_FLAG_STATUS_OPEN = 1;
   */
  OPEN = 1,

  /**
   * 承認（このままでよい）
   *
   * @generated from enum value: KNOWLEDGE_FLAG_STATUS_APPROVED = 2;
   */
  APPROVED = 2,

  /**
   * 修正済み（節の編集で解決。UpdateKnowledgeSection の origin_flag_id 経由で自動遷移）
   *
   * @generated from enum value: KNOWLEDGE_FLAG_STATUS_EDITED = 3;
   */
  EDITED = 3,

  /**
   * 棄却（フラグ自体が不要）
   *
   * @generated from enum value: KNOWLEDGE_FLAG_STATUS_DISMISSED = 4;
   */
  DISMISSED = 4,

  /**
   * 保留（**廃止済み**）。ワークスペースでは「スキップ＝後回し」が保留の役割を担うため、
   * 状態としての保留は 2026-08-25 に廃止した。値は wire / 既存データ互換のために残すだけで、
   * 書き込み経路は存在しない（既存行はmigration go/migrate/migrations/20261010152616_backfill_knowledge_usage_context_and_held_flags.sqlでOPENへ戻す）。
   *
   * @generated from enum value: KNOWLEDGE_FLAG_STATUS_ON_HOLD = 5;
   */
  ON_HOLD = 5,
}

/**
 * Describes the enum api_proto.v1.KnowledgeFlagStatus.
 */
export const KnowledgeFlagStatusSchema: GenEnum<KnowledgeFlagStatus> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_knowledge, 5);

